import {Injectable} from '@angular/core';
import { Http } from '@angular/http';
import {iRoute, iRouteWaypoint, iRouteCordinate, iRouteSlides} from '../service/Routes';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';

@Injectable()
export class RoutsService {
    constructor (private http: Http) {}
    private request: any = null;

    getRoots(): Promise<Array<iRoute>> {
        if(this.request == null){
            this.request = this.http.get('/restservice/routes')
                .map((response) => {
                    return response.json()
                })
                .toPromise();
        }

        return this.request;
    }
}



// WEBPACK FOOTER //
// ./assets_dev/ts/app/service/route.service.ts